import React from "react";
import useStore from "../store";
import strings from "../lang/Localiz";
import CommonPrizeList from "./CommonPrizeList";

function AlertContent() {
    let found_common_key = useStore((state) => state.found_common_key);
    let found_rare_key = useStore((state) => state.found_rare_key);
    let found_epic_key = useStore((state) => state.found_epic_key);
    let found_crystal = useStore((state) => state.found_crystal);

    let found_repair = useStore((state) => state.found_repair);
    let found_protection = useStore((state) => state.found_protection);
    let found_damage = useStore((state) => state.found_damage);
    let found_boost = useStore((state) => state.found_boost);
    let found_grenade = useStore((state) => state.found_grenade);
    let found_snowball = useStore((state) => state.found_snowball);
    let found_king = useStore((state) => state.found_king);
    let found_firework = useStore((state) => state.found_firework);

    found_common_key = found_common_key > 0 ? found_common_key : false;
    found_rare_key = found_rare_key > 0 ? found_rare_key : false;
    found_epic_key = found_epic_key > 0 ? found_epic_key : false;
    found_crystal = found_crystal > 0 ? found_crystal : false;

    found_repair = found_repair > 0 ? found_repair : false;
    found_protection = found_protection > 0 ? found_protection : false;
    found_damage = found_damage > 0 ? found_damage : false;
    found_boost = found_boost > 0 ? found_boost : false;
    found_grenade = found_grenade > 0 ? found_grenade : false;
    found_snowball = found_snowball > 0 ? found_snowball : false;
    found_king = found_king > 0 ? found_king : false;
    found_firework = found_firework > 0 ? found_firework : false;


    const summary = [
        found_common_key,
        found_rare_key,
        found_epic_key,
        found_crystal,
        found_repair,
        found_protection,
        found_damage,
        found_boost,
        found_grenade,
        found_snowball,
        found_king,
        found_firework,
    ];
    let summaryCount = 0;
    for (let t = 0; t <= summary.length - 1; t++) {
        if (summary[t]) {
            summaryCount++;
        }
    }
    const lang = strings.getLanguage();
    return (
        <div className={"store-alerts" + "  gift-count-" + summaryCount}>
            <div className={"alert-found-gift"}>
                <div className={"found-gift"}>
                    <CommonPrizeList
                        lang={lang}
                        showCommonKey={found_common_key > 0}
                        showRareKey={found_rare_key > 0}
                        showEpicKey={found_epic_key > 0}
                        showCrystals={found_crystal > 0}
                        showDamage={found_damage > 0}
                        showBoost={found_boost > 0}
                        showRepair={found_repair > 0}
                        showProtection={found_protection > 0}
                        showGrenade={found_grenade > 0}
                        showSnowball={found_snowball > 0}
                        showKing={found_king > 0}
                        showFirework={found_firework > 0}
                        common_key={found_common_key}
                        rare_key={found_rare_key}
                        epic_key={found_epic_key}
                        crystal={found_crystal}
                        damage={found_damage}
                        boost={found_boost}
                        repair={found_repair}
                        protection={found_protection}
                        grenade={found_grenade}
                        snowball={found_snowball}
                        king={found_king}
                        firework={found_firework}
                    />
                </div>
            </div>
        </div>
    );
}

export default AlertContent;
